var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardContainer',[(_vm.$storage.get('auth').user.user_type != 2)?_c('counter-tabs'):_vm._e(),(_vm.$storage.get('auth').user.user_type != 2)?_c('GraphGrid1'):_vm._e(),(_vm.$storage.get('auth').user.user_type != 2)?_c('GraphGrid2'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }